import { motion } from "framer-motion";


const wrapperVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1, y: 0,
        transition: {
            duration: 0.2,
            ease: "easeOut",
            when: "beforeChildren",
            staggerChildren: 0.18,
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.2, ease: "easeOut" } }
};

export default function MainBlock2() {
    return (
        <motion.div
            className="main-block main-block--2 container"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.35 }}
            variants={wrapperVariants}
        >
            <motion.div className="main-block__wrapper" variants={itemVariants}>
                <motion.h2 className="main-block__title" variants={itemVariants}>
                    A System That Thinks Ahead
                </motion.h2>
                <motion.span className="main-block__subtitle" variants={itemVariants}>
                    Investing isn’t a one-time event. Our system is built to evolve with the market — so you never fall behind.
                </motion.span>
                <motion.a
                    href={process.env.REACT_APP_LINK}
                    className="main-block__button button"
                    variants={itemVariants}
                    whileHover={{ scale: 1.07, boxShadow: "0 0 32px #ff00ac90" }}
                    whileTap={{ scale: 0.98 }}
                >
                    Open an Account
                </motion.a>
            </motion.div>
        </motion.div>
    );
}
